import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "d-inline-block",
  style: {"width":"168px"}
}
const _hoisted_2 = {
  class: "d-flex overflow-hidden mt-3",
  style: {"height":"8px"}
}
const _hoisted_3 = {
  class: "d-flex mt-3",
  style: {"gap":"4px"}
}

import { PropType } from 'vue';
import { TEMPERATURE_CONFIG, type TemperatureScaleConfig } from '@/constants/temperatureConstants';


export default /*@__PURE__*/_defineComponent({
  __name: 'TemperatureScale',
  props: {
  config: {
    type: Object as PropType<TemperatureScaleConfig>,
    required: true,
    default: () => TEMPERATURE_CONFIG
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.config.colors, (color, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex-fill",
          style: _normalizeStyle({ background: color })
        }, null, 4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.config.labels, (label, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex-fill text-center temp-labels"
        }, [
          _createElementVNode("span", null, _toDisplayString(label), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})